import { render, staticRenderFns } from "./hidden-products-query-ranking-modal.vue?vue&type=template&id=85a5bbc0&scoped=true"
import script from "./hidden-products-query-ranking-modal.vue?vue&type=script&lang=ts"
export * from "./hidden-products-query-ranking-modal.vue?vue&type=script&lang=ts"
import style0 from "./hidden-products-query-ranking-modal.vue?vue&type=style&index=0&id=85a5bbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a5bbc0",
  null
  
)

export default component.exports